import React,{ Component } from "react";
import ReactTable from "react-table";
import Pagination from '../../views/Pagination'

class LogTable extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { setPageSize, logs} = this.props;
        const data = logs && logs.data || [];
        let pageSize = data.length ? 100 : 5;
        setPageSize(pageSize);
    }

    render() {
        const {columns, logs, loading,sortChange,pageSize,pageNo,setPageSize,setPageNo} = this.props;
        
        const getPage = () => pageNo;
        const getPageSize = () => pageSize;
        const setPage = setPageNo;
        const hasMoreItems = () => logs && logs.data && ((pageNo + 1) * pageSize) < logs.data.length;

        if (columns && !loading) {
            return <ReactTable
                columns={columns}
                data={logs && logs.data || []}
                loading={loading}
                defaultPageSize={100}
                pageSizeOptions={[20, 50, 100, 250, 500, 1000]}
                getTrProps={(state, rowInfo) => {
                    if (rowInfo === undefined) {
                        return {}
                    }
                    return {
                        'data-qnt': rowInfo.original ? "1" : "0",
                        'data-value': rowInfo.original.levelname,
                        'data-allow':rowInfo.original.allow ? rowInfo.original.allow : "0"
                    }
                }}
                SubComponent={row => {
                    let text = row && row.original && Object.entries(row.original).map(([key, data]) => {
                            let error;
                            if ((key === 'traceback' || key === 'error_stack') && data !== null) {
                                error = data.split('\n').map((item, i) => {
                                    return <div className="text-danger" key={i}>{item}<br/></div>
                                });
                            }
                            return <div>
                                { data !== null ?
                                    <div>
                                        <span className="text-primary">{key}:</span> {error ? error : data}
                                    </div>
                                    : ''}
                            </div>
                        });
                    return (
                        <div className="pl-5">{text}</div>
                    );
                }}
                className="-striped -highlight"
                onSortedChange = {sortChange}
                PaginationComponent = {Pagination}
                pageSize = {pageSize}
                page = {pageNo}
                getPaginationProps={() => ({
                    getPage,
                    setPage,
                    getPageSize,
                    setPageSize,
                    hasMoreItems
                })}
            />
        }
        return '';

    }
}

export default LogTable;
